import { render, staticRenderFns } from "./LiffActivity.vue?vue&type=template&id=1b1f5fe0&scoped=true"
import script from "./LiffActivity.vue?vue&type=script&lang=js"
export * from "./LiffActivity.vue?vue&type=script&lang=js"
import style0 from "./LiffActivity.vue?vue&type=style&index=0&id=1b1f5fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f5fe0",
  null
  
)

export default component.exports